import { joinURL, withBase } from 'ufo'

export type ImageFit = 'fit' | 'fill'
function urlSafeBase64(value: string) {
  const base64 = window.btoa(value)
  return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export default function getImageUrl({
  file,
  width,
  height,
  ppoi,
  imageFit
}: {
  file: string
  width: number
  height: number
  ppoi: [string, string]
  imageFit: ImageFit
}) {
  const encodedUrl = urlSafeBase64(file)
  const [x, y] = ppoi
  const rsTransform = `rs:${imageFit}:${width}:${height}:1`
  const gravityTransform = `g:fp:${x}:${y}`
  const transforms = [rsTransform, gravityTransform]
  const path = `/${transforms.join('/')}/${encodedUrl}`
  const baseURL = import.meta.env.VITE_IMAGEPROXY_URL
  if (!baseURL) return
  return withBase(joinURL('_', path), baseURL)
}
